import { apiGet, apiPut } from '../client';
import type {
  BankAccountListResponseApi,
  BankAccountApi,
  UpdateBankAccountRequestApi,
} from '../models/bankAccount';

export async function getAllBankAccounts(): Promise<BankAccountListResponseApi> {
  return apiGet<BankAccountListResponseApi>('bank-accounts');
}

export async function getBankAccountById(bankAccountId: number): Promise<BankAccountApi | null> {
  try {
    return await apiGet<BankAccountApi>(`bank-accounts/${bankAccountId}`);
  } catch (error) {
    if (error instanceof Error && 'status' in error && (error as { status: number }).status === 404) {
      return null;
    }
    throw error;
  }
}

export async function updateBankAccount(
  bankAccountId: number,
  request: UpdateBankAccountRequestApi
): Promise<BankAccountApi> {
  return apiPut<BankAccountApi>(`bank-accounts/${bankAccountId}`, request);
}
